import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../state/auth.tsx';
import { Alert, Spinner } from '../components/ui.tsx';

export default function Verify() {
  const [params] = useSearchParams();
  const { verify } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState<'working' | 'done' | 'failed'>('working');
  // React 19 runs effects twice in development; the token is single-use, so a second attempt
  // would fail a confirmation that actually worked.
  const attempted = useRef(false);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState('failed');
      return;
    }
    if (attempted.current) return;
    attempted.current = true;

    void verify(token)
      .then(() => {
        setState('done');
        setTimeout(() => navigate('/', { replace: true }), 900);
      })
      .catch(() => setState('failed'));
  }, [params, verify, navigate]);

  return (
    <div className="content narrow">
      <div className="stack center">
        {state === 'working' && (<><Spinner label="Conferma in corso" /><p className="muted">Sto confermando il tuo indirizzo…</p></>)}
        {state === 'done' && (<><h1>Fatto</h1><Alert kind="info">Account attivo. Ti porto alle tue carte.</Alert></>)}
        {state === 'failed' && (
          <>
            <h1>Link non valido</h1>
            <Alert kind="error">Questo link è scaduto o è già stato usato.</Alert>
            <p className="muted">Puoi <Link to="/login">provare a entrare</Link>: se l’account è già attivo funziona.</p>
          </>
        )}
      </div>
    </div>
  );
}
